<template><div><h1 id="ereigniskostenerfassung" tabindex="-1"><a class="header-anchor" href="#ereigniskostenerfassung"><span>Ereigniskostenerfassung</span></a></h1>
<p>Ereigniskostenerfassung — Erfassungstabelle für Ereigniskosten</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Ereigniskosten können in 2 Varianten erfasst werden:</p>
<ol>
<li>
<p>Direkte Erfassung von Rechnungen mit den den entsprechenden Kontendaten.</p>
</li>
<li>
<p>Erfassung als Position in einer frei definierbaren Kostenstruktur.</p>
</li>
</ol>
<p>Es ist auch möglich, beide Varianten zu mischen, z.B. Erfassung von Rechnungen für Druck und Porti, sowie Eintrag der Personalkosten als Kostenstruktur-Position.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Ereigniskosten-Erfassung</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Datum</dt>
<dd>Rechnungsdatum, resp. Datum zu dem die Kosten gerechnet werden sollen.</dd>
<dt>Betrag</dt>
<dd>Kostenbetrag</dd>
<dt>verteilbar</dt>
<dd>Restbetrag, der in der Tabelle <a class="link" href="ft.refdata.tblereigniskostenaufteilung.html" title="Ereigniskostenaufteilung">Ereigniskostenaufteilung</a> noch nicht aufgeteilt ist.</dd>
<dt>Struktur</dt>
<dd>Position aus der <a class="link" href="ft.refdata.tblereigniskostenstruktur.html" title="Ereigniskostenstruktur">Ereigniskostenstruktur</a>. Wenn dieses Feld ausgefüllt ist, sind die Felder &quot;Konto&quot;/&quot;Kostenstelle&quot;/&quot;Kostenträger&quot; für die Erfassung gesperrt.</dd>
<dt>Konto/Kontobezeichnung</dt>
<dd><a class="link" href="ft.refdata.konti.html" title="Konti">Konto</a>. Wenn dieses Feld ausgefüllt ist, ist das Feld &quot;Struktur&quot; für die Erfassung gesperrt.</dd>
<dt>Kostenstelle/Kst.-Bezeichnung</dt>
<dd><a class="link" href="ft.refdata.kst.html" title="Kostenstellen">Kostenstelle</a>.</dd>
<dt>Kostenträger/Ktr.-Bezeichnung</dt>
<dd><a class="link" href="ft.refdata.ktr.html" title="Kostenträger">Kostenträger</a>.</dd>
<dt>Beleg-Nr</dt>
<dd>Eintrag einer beliebigen Belegnummer.</dd>
<dt>Lieferant</dt>
<dd>Eintrag des Rechnungsstellers/Lieferanten.</dd>
<dt>Bemerkung</dt>
<dd>Eintrag von beliebigen Zusatzinformationen.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.tblereigniskostenaufteilung.html" title="Ereigniskostenaufteilung">Ereigniskostenaufteilung</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.tblereigniskostenstruktur.html" title="Ereigniskostenstruktur">Ereigniskostenstruktur</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.konti.html" title="Konti">Konto</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.kst.html" title="Kostenstellen">Kostenstelle</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.ktr.html" title="Kostenträger">Kostenträger</RouteLink></p>
</div></template>


